// Generated by scripts/update-seeq-icons.js from src/svg/seeq/bell-solid.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcBellSolid = {
  prefix: 'fak',
  iconName: 'bell-solid' as IconName,
  icon: [
    896,
    1024,
    [],
    'e9a1',
    'M448 0c-35.4 0-64 28.6-64 64v38.4c-146 29.6-256 158.8-256 313.6v37.6c0 94-34.6 184.8-97 255.2l-14.8 16.6c-16.8 18.8-20.8 45.8-10.6 68.8s33.2 37.8 58.4 37.8h768c25.2 0 48-14.8 58.4-37.8s6.2-50-10.6-68.8l-14.8-16.6c-62.4-70.4-97-161-97-255.2v-37.6c0-154.8-110-284-256-313.6v-38.4c0-35.4-28.6-64-64-64zM538.6 986.6c24-24 37.4-56.6 37.4-90.6h-256c0 34 13.4 66.6 37.4 90.6s56.6 37.4 90.6 37.4 66.6-13.4 90.6-37.4z',
  ],
} satisfies IconDefinition;
